/** Sell Your Car public page (Milestone 1 — page shell). */

export const SELL_YOUR_CAR_PATH = "/vender-mi-carro";

export const SELL_YOUR_CAR_FORM_SECTION_ID = "formulario-venta";

export const SELL_YOUR_CAR_SEARCH_HREF = "/comprar/carros-usados";

export const SELL_YOUR_CAR_UNAVAILABLE_COPY = Object.freeze({
  title: "Envío temporalmente no disponible",
  body: "El formulario de venta no está disponible en este momento. Puedes explorar carros en venta o volver más tarde.",
});

export const SELL_YOUR_CAR_VALUE_CARDS = Object.freeze([
  {
    title: "Publicación guiada",
    copy: "Te ayudamos a organizar los datos importantes del vehículo antes de publicarlo.",
  },
  {
    title: "Precio más claro",
    copy: "Usa referencias del mercado para entender si tu precio está alineado con vehículos similares.",
  },
  {
    title: "Más confianza para compradores",
    copy: "Una publicación completa ayuda a responder preguntas antes del primer contacto.",
  },
  {
    title: "Revisión antes de publicar",
    copy: "AutoMapa puede revisar la información para mejorar calidad, claridad y seguridad.",
  },
]);

export const SELL_YOUR_CAR_STEPS = Object.freeze([
  "Envías los datos del vehículo",
  "Revisamos la información",
  "Preparamos la publicación o te contactamos",
]);

export const SELL_YOUR_CAR_INFO_CHECKLIST = Object.freeze([
  { label: "Marca, modelo y año" },
  { label: "Versión o línea" },
  { label: "Kilometraje" },
  { label: "Ciudad" },
  { label: "Precio esperado" },
  { label: "Estado general" },
  { label: "Fotos del vehículo", note: "Opcional" },
  { label: "Nombre y teléfono o WhatsApp" },
  { label: "Correo electrónico (opcional)" },
]);

export const SELL_YOUR_CAR_SELLER_TYPES = Object.freeze([
  "Personas vendiendo su carro",
  "Pequeños concesionarios",
  "Lotes independientes",
  "Dealers que quieren publicar inventario",
]);

export const SELL_YOUR_CAR_FAQ = Object.freeze([
  {
    question: "¿AutoMapa compra mi carro?",
    answer:
      "No necesariamente. AutoMapa ayuda a organizar y revisar la información para una posible publicación o contacto con compradores y concesionarios.",
  },
  {
    question: "¿La publicación es automática?",
    answer: "No. La información puede ser revisada antes de publicarse.",
  },
  {
    question: "¿Debo subir fotos?",
    answer:
      "No es obligatorio, pero las fotos claras del exterior, interior y tablero ayudan mucho a preparar una mejor publicación.",
  },
  {
    question: "¿AutoMapa garantiza la venta?",
    answer:
      "No. AutoMapa ayuda a presentar mejor la información, pero no garantiza una venta.",
  },
  {
    question: "¿Puedo publicar si soy concesionario?",
    answer:
      "Sí. El flujo también puede servir para concesionarios o lotes que quieran enviar inventario para revisión.",
  },
]);
